import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

export default class Layout extends Component {
  static displayName = Layout.name;

  render() {
      return (
          <div>
              <Navbar />
              <Container>
                  <Outlet />
              </Container>
          </div>
      );
  }
}
